export const Actions = {
    NOTIFICATION_POST: 'NOTIFICATION_POST',
    NOTIFICATION_CLEAR: 'NOTIFICATION_CLEAR',
};
